import axiosApi from '../api/axiosApi';
import { GET_COMPANIES, POST_COMPANY, UPDATE_COMPANY } from '../common/constants/constants';
import { Companies } from '../common/types/types';

class CompaniesService {
  getCompanies() {
    return axiosApi.get(GET_COMPANIES);
  }
  addCompany(request: Partial<Companies>) {
    return axiosApi.post(POST_COMPANY, request);
  }
  updateCompany(request: Partial<Companies>) {
    return axiosApi.put(UPDATE_COMPANY + '/' + request.id, request);
  }
}

export default new CompaniesService();
